module.exports = __webpack_public_path__ + "static/media/43.d170f575.png";